
import React from 'react';
import { motion, Variants } from 'framer-motion';

interface Props {
  title: string;
  subtitle?: string;
  centered?: boolean;
}

const SectionHeading: React.FC<Props> = ({ title, subtitle, centered = false }) => {
  const words = title.split(" ");

  const container: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const child: Variants = {
    visible: {
      opacity: 1,
      y: 0,
      transition: { 
        type: "spring", 
        damping: 15, 
        stiffness: 100 
      },
    },
    hidden: { 
      opacity: 0, 
      y: 20,
      transition: { 
        type: "spring", 
        damping: 15, 
        stiffness: 100 
      },
    },
  };

  return (
    <motion.div 
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      variants={container}
      className={`mb-12 md:mb-20 ${centered ? 'text-center' : ''}`}
    >
      <div className={`flex flex-wrap ${centered ? 'justify-center' : 'justify-start'} gap-x-3 md:gap-x-4 mb-4 md:mb-6`}>
        {words.map((word, index) => (
          <motion.h2
            key={index}
            variants={child}
            className="text-3xl md:text-7xl font-[900] tracking-tighter text-white"
          >
            {word}
          </motion.h2>
        ))}
      </div>
      
      {subtitle && (
        <motion.p 
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="text-gray-400 text-base md:text-xl max-w-2xl mx-auto font-medium leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
      <motion.div 
        initial={{ width: 0 }}
        whileInView={{ width: 60 }}
        transition={{ delay: 0.8, duration: 1.2, ease: "circOut" }}
        className={`h-1.5 md:h-2 bg-rose-600 rounded-full mt-6 md:mt-8 ${centered ? 'mx-auto' : ''}`} 
      />
    </motion.div>
  );
};

export default SectionHeading;
